import { useQuery } from 'react-query'

import { useSvcCrunchesContext } from '@dc-shared-web/providers/SvcCrunchesProvider'

import { AIUserFeedback } from '@dc-shared-web/hooks/api/ai-user-feedback/types'
import {
  getAIUserFeedback,
  GetAIUserFeedbackParams,
} from '@dc-shared-web/hooks/api/ai-user-feedback/getAIUserFeedback'

type AIUserFeedbackResult = {
  total: number
  limit: number
  page: number
  totalpages: number
  results: AIUserFeedback[]
}

export const useGetAIUserFeedback = (
  params: GetAIUserFeedbackParams,
  options: {
    enabled: boolean
  }
) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery<AIUserFeedbackResult, Error>(
    ['ai-user-feedback', `feedback-${params.content_uuid}`, params],
    () => getAIUserFeedback(apiClient, params),
    {
      retry: false,
      enabled: options.enabled,
    }
  )
}
